import { StyleDeclarationValue, css } from 'aphrodite';
import * as React from 'react';
import { LogoIcon2023 } from '../../../web/components/svgs/icons/LogoIcon2023';
import { black } from '../../../web/styles/colors';
import { SurveyHeader } from '../../components/surveys/SurveyHeader';
import { ISurvey } from '../../models/Api';
import { styleSheet } from './styles';

interface IProps<T extends ISurvey> {
	cardStyles?: StyleDeclarationValue[];
	className?: string;
	contentStyles?: StyleDeclarationValue[];
	onRenderFooter?(): React.ReactNode;
	onRenderHeader?(styles?: StyleDeclarationValue[]): React.ReactNode;
	styles?: StyleDeclarationValue[];
	survey?: T;
}

export function Survey<T extends ISurvey>({
	cardStyles = [],
	children,
	className = '',
	contentStyles = [],
	onRenderFooter,
	onRenderHeader,
	styles = [],
	survey,
}: React.PropsWithChildren<IProps<T>>) {
	return (
		<div className={`survey-container ${className} ${css(styleSheet.container, ...styles)}`}>
			<div className={css(styleSheet.content, ...cardStyles)}>
				{onRenderHeader?.([styleSheet.header]) || (
					<SurveyHeader
						companyDisplayName={survey?.companyDisplayName}
						name={survey?.name || 'Survey'}
						styles={[styleSheet.header]}
					/>
				)}
				<div className={css(styleSheet.body, ...contentStyles)}>{children}</div>
			</div>
			<div className={css(styleSheet.footer)}>
				{onRenderFooter?.() || (
					<>
						<div className={css(styleSheet.poweredBy)}>Powered by</div>
						<a href='https://levitate.ai' target='_blank' rel='noopener noreferrer'>
							<LogoIcon2023 className={css(styleSheet.mainLogo)} textColor={black} />
						</a>
					</>
				)}
			</div>
		</div>
	);
}
